import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Profile, ProfileService} from "../../services/profile.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['home.component.scss']
})
export class HomeComponent implements OnInit {
  profile: Profile;

  constructor(private authService: AuthService, private profileService: ProfileService) {
  }

  ngOnInit(): void {
    this.profileService.get().subscribe(data => this.profile = data);
  }

  logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/home.component.ts